import { useTranslation } from "react-i18next";
import styles from "./styles.module.scss";

const ComparePacksModal = () => {
  const { t } = useTranslation("global");
  return (
    <div className={styles.compareModal}>
      <div className={styles.modalDialog}>
        <main className={styles.modalBody}>
          <article>
            <table>
              <thead>
                <tr>
                  <th className={styles.hide}></th>
                  <th></th>
                  <th className={styles.bgPink}>
                    {t("modal.compare.memberPlus")}
                  </th>
                  <th className={styles.bgBlue}>
                    {t("modal.compare.freemium")}
                  </th>
                  <th className={styles.bgBronze}>
                    {t("modal.compare.packBronze")}
                  </th>
                  <th className={styles.bgSilver}>
                    {t("modal.compare.packSilver")}
                  </th>
                  <th className={styles.bgGold}>
                    {t("modal.compare.packGold")}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td colSpan="6" className={styles.sep}>
                    {t("modal.compare.visibilityOptions")}
                  </td>
                </tr>
                <tr>
                  <td>{t("modal.compare.optionPhotos")}</td>
                  <td>
                    <span className={styles.tick}>&#10004;</span>
                  </td>
                  <td>
                    <span className={styles.cross}>&#x2717;</span>
                  </td>
                  <td>
                    <span className={styles.tick}>&#10004;</span>
                  </td>
                  <td>
                    <span className={styles.tick}>&#10004;</span>
                  </td>
                  <td>
                    <span className={styles.tick}>&#10004;</span>
                  </td>
                </tr>
                <tr>
                  <td>{t("modal.compare.optionFavorite")}</td>
                  <td>
                    <span className={styles.tick}>&#10004;</span>
                  </td>
                  <td>
                    <span className={styles.cross}>&#x2717;</span>
                  </td>
                  <td>
                    <span className={styles.tick}>&#10004;</span>
                  </td>
                  <td>
                    <span className={styles.tick}>&#10004;</span>
                  </td>
                  <td>
                    <span className={styles.cross}>&#x2717;</span>
                  </td>
                </tr>
                <tr>
                  <td>{t("modal.compare.optionFirstPage")}</td>
                  <td>
                    <span className={styles.tick}>&#10004;</span>
                  </td>
                  <td>
                    <span className={styles.cross}>&#x2717;</span>
                  </td>
                  <td>
                    <span className={styles.cross}>&#x2717;</span>
                  </td>
                  <td>
                    <span className={styles.tick}>&#10004;</span>
                  </td>
                  <td>
                    <span className={styles.tick}>&#10004;</span>
                  </td>
                </tr>
                <tr>
                  <td>{t("modal.compare.optionColor")}</td>
                  <td>
                    <span className={styles.cross}>&#x2717;</span>
                  </td>
                  <td>
                    <span className={styles.cross}>&#x2717;</span>
                  </td>
                  <td>
                    <span className={styles.cross}>&#x2717;</span>
                  </td>
                  <td>
                    <span className={styles.cross}>&#x2717;</span>
                  </td>
                  <td>
                    <span className={styles.tick}>&#10004;</span>
                  </td>
                </tr>
                <tr>
                  <td>{t("modal.compare.commission")}</td>
                  <td>
                    <span className={styles.txtL}>15%</span>
                  </td>
                  <td>
                    <span className={styles.txtL}>10%</span>
                  </td>
                  <td>
                    <span className={styles.txtL}>15%</span>
                  </td>
                  <td>
                    <span className={styles.txtL}>20%</span>
                  </td>
                  <td>
                    <span className={styles.txtL}>22%</span>
                  </td>
                </tr>
                <tr>
                  <td colSpan="6" className={styles.sep}>
                    {t("modal.compare.complimentaryServices")}
                  </td>
                </tr>
                <tr>
                  <td>{t("modal.compare.acessToPlatform")}</td>
                  <td>
                    <span className={styles.tick}>&#10004;</span>
                  </td>
                  <td>
                    <span className={styles.tick}>&#10004;</span>
                  </td>
                  <td>
                    <span className={styles.tick}>&#10004;</span>
                  </td>
                  <td>
                    <span className={styles.tick}>&#10004;</span>
                  </td>
                  <td>
                    <span className={styles.tick}>&#10004;</span>
                  </td>
                </tr>
                <tr>
                  <td>{t("modal.compare.disposition")}</td>
                  <td>
                    <span className={styles.tick}>&#10004;</span>
                  </td>
                  <td>
                    <span className={styles.tick}>&#10004;</span>
                  </td>
                  <td>
                    <span className={styles.tick}>&#10004;</span>
                  </td>
                  <td>
                    <span className={styles.tick}>&#10004;</span>
                  </td>
                  <td>
                    <span className={styles.tick}>&#10004;</span>
                  </td>
                </tr>
                <tr>
                  <td>{t("modal.compare.landingPage")}</td>
                  <td>
                    <span className={styles.tick}>&#10004;</span>
                  </td>
                  <td>
                    <span className={styles.cross}>&#x2717;</span>
                  </td>
                  <td>
                    <span className={styles.cross}>&#x2717;</span>
                  </td>
                  <td>
                    <span className={styles.cross}>&#x2717;</span>
                  </td>
                  <td>
                    <span className={styles.cross}>&#x2717;</span>
                  </td>
                </tr>
                <tr>
                  <td>{t("modal.compare.tarifs")}</td>
                  <td>
                    <span className={styles.tick}>&#10004;</span>
                  </td>
                  <td>
                    <span className={styles.cross}>&#x2717;</span>
                  </td>
                  <td>
                    <span className={styles.cross}>&#x2717;</span>
                  </td>
                  <td>
                    <span className={styles.cross}>&#x2717;</span>
                  </td>
                  <td>
                    <span className={styles.cross}>&#x2717;</span>
                  </td>
                </tr>
                <tr>
                  <td>{t("modal.compare.meetings")}</td>
                  <td>
                    <span className={styles.tick}>&#10004;</span>
                  </td>
                  <td>
                    <span className={styles.cross}>&#x2717;</span>
                  </td>
                  <td>
                    <span className={styles.cross}>&#x2717;</span>
                  </td>
                  <td>
                    <span className={styles.cross}>&#x2717;</span>
                  </td>
                  <td>
                    <span className={styles.cross}>&#x2717;</span>
                  </td>
                </tr>
                <tr>
                  <td>{t("modal.compare.monthlyFee")}</td>
                  <td>
                    <span className={styles.txtL}>
                      {`164 ${t("modal.compare.monthlyNoVat")}`}
                    </span>
                  </td>
                  <td>
                    <span className={styles.txtL}>
                      {" "}
                      {t("modal.compare.paidInAdvance")}
                    </span>
                  </td>
                  <td>
                    <span className={styles.txtL}>
                      {t("modal.compare.paidInAdvance")}
                    </span>
                  </td>
                  <td>
                    <span className={styles.txtL}>
                      {t("modal.compare.paidInAdvance")}
                    </span>
                  </td>
                  <td>
                    <span className={styles.txtL}>
                      {t("modal.compare.paidInAdvance")}
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </article>
        </main>
      </div>
    </div>
  );
};

export default ComparePacksModal;
